type Props = {
  src: string;
};
export const ActiveChatImage = ({ src }: Props) => {
  return <img src={src} alt="src" className="h-auto max-w-[250px]" />;
};
